import { GeneralProgressBar } from './general-progress-bar'
import { CircularProgressBar } from './circular-progress-bar'


const ProgressBar = Object.assign(GeneralProgressBar, {
    Default: GeneralProgressBar,
    Circular: CircularProgressBar,
})

export default ProgressBar